import React from 'react'
import * as tag from "./Card.style"
import Icon from "../../../Pages/ProjectPage/Icons.datafile"

const Card = ({project}) => {
	/*
		https://drive.google.com/open?id=

		[0] = https://drive.google.com/open?id
		[1] = 1CrHUwC5vZSeyw053XkzyQlmgRgTbGZK-
	*/

	let extractor = (link) => {
		if (link.search("google.com") !== -1) {
			var id = link.split("=");
			let url_link = "https://drive.google.com/uc?export=view&id=";
			var url = url_link.concat(id[1]);
		} else {
			url = link;
		}
		return url;
	}

	let iconImages = (icons) => {
		let setOfIcons = icons.split(", ");
		for(let i = 0; i <= setOfIcons.length - 1; i++){
			for(let j = 0; j < Icon.length; j++){
				if(setOfIcons[i] === Icon[j].lang){
					if(setOfIcons[i] !== "None")
						setOfIcons[i] = Icon[j].icon;
					else
						setOfIcons[i] = null;
				}
			}
		}
		return setOfIcons;
	}

	return (
		<tag.Container>
			<tag.ImgContainer bgImage={extractor(project[4])}>
				<tag.TechnologyContainer>
					{iconImages(project[13]).map((icon,key) => {
						return <tag.Technology src={icon} key={key} />
					})}
				</tag.TechnologyContainer>
			</tag.ImgContainer>
			<tag.TextContainer>
				<tag.Heading>{project[1]}</tag.Heading>
				<tag.Text>
				{
					project[2].length >= 150 
					? project[2].substr(0,170).substr(0, Math.min(project[2].substr(0,170).length, project[2].substr(0,170).lastIndexOf(" "))).concat("...")
					: project[2]}</tag.Text>
			</tag.TextContainer>
			<tag.InfoContainer>
				<tag.OwnerContainer>
					<tag.OwnerPicContainer photo={extractor(project[10])}></tag.OwnerPicContainer>
					<tag.OwnerNameSocialContainer>
						<tag.OwnerName>{project[5]}</tag.OwnerName>
						<tag.OwnerSocialHandle>
							{
								project[3] !== ""
								? <tag.Href href={project[3]} ><tag.I className="fab fa-github" ></tag.I></tag.Href>
								: null 
							}
							{
								project[6] !== ""
								? <tag.Href href={project[3]} ><tag.I className="fab fa-linkedin" ></tag.I></tag.Href>
								: null 
							}
							{
								project[7] !== ""
								? <tag.Href href={project[3]} ><tag.I className="fab fa-twitter" ></tag.I></tag.Href>
								: null 
							}
						</tag.OwnerSocialHandle>
					</tag.OwnerNameSocialContainer>
				</tag.OwnerContainer>
				<tag.ProjectLinkBtnContainer>
					<tag.LinkTag href={project[8]}>
						<tag.ProjectLinkBtn>View Project</tag.ProjectLinkBtn>
					</tag.LinkTag>
				</tag.ProjectLinkBtnContainer>
			</tag.InfoContainer>
		</tag.Container>
	)
}

export default Card
